import { hextorstr, KEYUTIL, KJUR, stob64 } from 'jsrsasign';
import * as qz from 'qz-tray';

import { QzTrayCertificate, QzTrayPrivateKey } from '../constants';

export function setQzTrayLicense() {
  qz.security.setCertificatePromise((resolve, reject) => resolve(QzTrayCertificate));
  qz.security.setSignatureAlgorithm('SHA512'); // Since 2.1
  qz.security.setSignaturePromise((toSign) => (resolve, reject) => {
    try {
      const pk = KEYUTIL.getKey(QzTrayPrivateKey);
      const sig = new KJUR.crypto.Signature({ alg: 'SHA512withRSA' }); // Use "SHA1withRSA" for QZ Tray 2.0 and older
      sig.init(pk);
      sig.updateString(toSign);
      const hex = sig.sign();
      // console.log('DEBUG: \n\n' + stob64(hextorstr(hex)));
      resolve(stob64(hextorstr(hex)));
    } catch (err) {
      console.error(err);
      reject(err);
    }
  });
}
